/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react';
import { Box } from '@mui/material';

export type TAnimatedBackgroundProps = {
	children: React.ReactNode;
};

export const AnimatedBackground: FC<TAnimatedBackgroundProps> = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignContent: 'center',
				justifyContent: 'center',
				height: { xs: '100vh', sm: 'auto' },
				color: '#016193',
				position: 'relative',
				backgroundColor: '#052437',
			}}
		>
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100vw',
					height: 'calc(100% + 20px)',
					minHeight: '100vh',
					backgroundColor: '#052437',
					overflow: 'hidden',
					display: { xs: 'block', md: 'none' },
				}}
			/>

			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100vw',
					height: 'calc(100% + 20px)',
					minHeight: '100vh',
					backgroundColor: '#052437',
					overflow: 'hidden',
					display: { xs: 'none', md: 'block' },
				}}
			>
				<div
					style={{
						position: 'absolute',
						top: '10vw',
						left: '-10vw',
						width: '10vw',
						height: '10vh',
						backgroundColor: '#39d1ff',
						borderRadius: '50%',
						zIndex: 2,
						mixBlendMode: 'lighten',
						filter: 'blur(100px)',
						animationDuration: '10s',
						animationName: 'blinking',
						animationIterationCount: 'infinite',
						animationDirection: 'alternate',
						animationTimingFunction: 'ease-in-out',
					}}
				/>
				<div
					style={{
						position: 'absolute',
						bottom: '10vw',
						right: '-50vw',
						width: '10vw',
						height: '10vh',
						backgroundColor: '#39d1ff',
						borderRadius: '50%',
						zIndex: 2,
						mixBlendMode: 'lighten',
						filter: 'blur(100px)',
						animationDuration: '13s',
						animationName: 'blinking3',
						animationIterationCount: 'infinite',
						animationDirection: 'alternate',
						animationTimingFunction: 'ease-in-out',
					}}
				/>

				<div
					style={{
						position: 'absolute',
						bottom: '10vw',
						right: '-10vw',
						width: '10vw',
						height: '10vh',
						backgroundColor: '#39d1ff',
						borderRadius: '50%',
						zIndex: 2,
						mixBlendMode: 'lighten',
						filter: 'blur(300px)',
						animationDuration: '5s',
						animationName: 'blinking2',
						animationIterationCount: 'infinite',
						animationDirection: 'alternate',
						animationTimingFunction: 'ease-in-out',
					}}
				/>
				<div
					style={{
						position: 'absolute',
						top: '10vw',
						left: '-10vw',
						width: '10vw',
						height: '10vh',
						backgroundColor: '#39d1ff',
						borderRadius: '50%',
						zIndex: 2,
						mixBlendMode: 'lighten',
						filter: 'blur(300px)',
						animationDuration: '15s',
						animationName: 'blinking2',
						animationIterationCount: 'infinite',
						animationDirection: 'alternate',
						animationTimingFunction: 'ease-in-out',
					}}
				/>
			</Box>
			{children}
		</Box>
	);
};
